// mds-dojo — FAITHFUL port of dojox/html/metrics (dojo 1.x), evergreen.
// Additive canonical dep (none existed before); dojox/calendar (_ScrollBarBase,
// SimpleColumnView, MonthColumnView) uses metrics.getScrollbar().
//
// ⚠️ EVERGREEN DEVIATIONS (LOUD): the IE font-size fix in getFontMeasurements is
//    dropped (has("ie") branch); the font-resize <iframe> machinery
//    (initOnFontResize/_fontresize/onFontResize + dojo/_base/unload teardown) is
//    dropped — it was IE/legacy-zoom-era, gated OFF unless config.fontSizeWatch,
//    and unused by the calendar family. getFontMeasurements/getCachedFontMeasurements/
//    getTextBox/getScrollbar are faithful. Scrollbar is measured on dojo/ready
//    exactly like the source (default {w:16,h:16} until then).
import lang from '../../dojo/_base/lang';
import ready from '../../dojo/ready';
import Window from '../../dojo/_base/window';
import DOMGeom from '../../dojo/dom-geometry';

var dhm: any = lang.getObject('dojox.html.metrics', true);

// derived from Morris John's emResized measurer
dhm.getFontMeasurements = function () {
	// summary:
	//		Returns an object that has pixel equivilents of standard font size values.
	var heights: any = {
		'1em': 0, '1ex': 0, '100%': 0, '12pt': 0, '16px': 0, 'xx-small': 0, 'x-small': 0,
		'small': 0, 'medium': 0, 'large': 0, 'x-large': 0, 'xx-large': 0
	};

	// set up the measuring node.
	var div = Window.doc.createElement('div');
	var ds = div.style;
	ds.position = 'absolute';
	ds.left = '-100px';
	ds.top = '0';
	ds.width = '30px';
	ds.height = '1000em';
	ds.borderWidth = '0';
	ds.margin = '0';
	ds.padding = '0';
	ds.outline = '0';
	ds.lineHeight = '1';
	ds.overflow = 'hidden';
	Window.body().appendChild(div);

	// do the measurements.
	for (var p in heights) {
		ds.fontSize = p;
		heights[p] = Math.round(div.offsetHeight * 12 / 16) * 16 / 12 / 1000;
	}

	Window.body().removeChild(div);
	div = null as any;
	return heights; 	//	object
};

var fontMeasurements: any = null;

dhm.getCachedFontMeasurements = function (recalculate?: any) {
	if (recalculate || !fontMeasurements) {
		fontMeasurements = dhm.getFontMeasurements();
	}
	return fontMeasurements;
};

var measuringNode: any = null, empty: any = {};
dhm.getTextBox = function (/* String */ text: any, /* Object */ style: any, /* String? */ className?: any) {
	var m, s;
	if (!measuringNode) {
		m = measuringNode = Window.doc.createElement('div');
		// Due to fixing the parent node's width below, texts which contain white-spaces would be wrapped. Avoid this.
		m.style.whiteSpace = 'nowrap';
		// Container that we can set constraints on so that it doesn't trigger a scrollbar.
		var c = Window.doc.createElement('div');
		c.appendChild(m);
		s = c.style;
		s.overflow = 'scroll';
		s.position = 'absolute';
		s.left = '0px';
		s.top = '-10000px';
		s.width = '1px';
		s.height = '1px';
		s.visibility = 'hidden';
		s.borderWidth = '0';
		s.margin = '0';
		s.padding = '0';
		s.outline = '0';
		Window.body().appendChild(c);
	} else {
		m = measuringNode;
	}
	// reset styles
	m.className = '';
	s = m.style;
	s.borderWidth = '0';
	s.margin = '0';
	s.padding = '0';
	s.outline = '0';
	// set new style
	if (arguments.length > 1 && style) {
		for (var i in style) {
			if (i in empty) { continue; }
			s[i] = style[i];
		}
	}
	// set classes
	if (arguments.length > 2 && className) {
		m.className = className;
	}
	// take a measure
	m.innerHTML = text;
	var box = DOMGeom.position(m);
	// position doesn't report right (reports 1, since parent is 1)
	// So we have to look at the scrollWidth to get the real width. Height is right.
	box.w = m.parentNode.scrollWidth;
	return box;
};

// determine the scrollbar sizes on load.
var scroll = { w: 16, h: 16 };
dhm.getScrollbar = function () { return { w: scroll.w, h: scroll.h }; };

dhm._fontResizeNode = null;
dhm.initOnFontResize = function (/*interval*/) { /* evergreen no-op — see header */ };
dhm.onFontResize = function () { };
dhm._fontresize = function () { dhm.onFontResize(); };

ready(function () {
	// getScrollbar metrics node
	try {
		var n = Window.doc.createElement('div');
		n.style.cssText = 'top:0;left:0;width:100px;height:100px;overflow:scroll;position:absolute;visibility:hidden;';
		Window.body().appendChild(n);
		scroll.w = n.offsetWidth - n.clientWidth;
		scroll.h = n.offsetHeight - n.clientHeight;
		Window.body().removeChild(n);
	} catch (e) { }
});

export default dhm;
